module.exports = __webpack_public_path__ + "img/cotton_harvest.326313da.svg";